// tslint:disable-next-line:no-shadowed-variable
import { ConfigModel } from '../core/interfaces/config';

// tslint:disable-next-line:no-shadowed-variable


export class MenuConfig implements ConfigModel {
    public config: any = {};
    displayItems = JSON.parse(localStorage.getItem('permissions'))

    constructor() {
        let stageCount = localStorage.getItem('stageCount');
        let partExpiringCount = localStorage.getItem('partsExpiringCount');
        let partExpiredCount = localStorage.getItem('partExpiredCount');

        this.config = {
            header: {
                self: {},
                items: [
                ]
            },
            aside: {
                self: {},
                items: [{
                    title: 'MENU.DASHBOARD',
                    translate: 'MENU.DASHBOARD',
                    desc: 'dashboard',
                    root: true,
                    icon: 'fas fa-chart-line',
                    page: '/dashboard',
                },
            ]
            }
        };
        this.config.aside.items.push({
            title: 'MENU.PLANS',
            translate: 'MENU.PLANS',
            desc: 'AED listing, details and action',
            root: true,
            icon: 'fas fa-shopping-bag',
            page: '/subscription-list',
        },
        )
        if (this.displayItems && this.displayItems.add_company) {
            this.config.aside.items.push({
                title: 'MENU.COMPANY',
                translate: 'MENU.COMPANY',
                desc: 'Users listing, details and action',
                root: true,
                icon: 'fas fa-building',
                page: '/manage-company',

            })
        }
        if (this.displayItems && this.displayItems.aed_sites) {
            this.config.aside.items.push({
                title: 'MENU.MANAGE_SITES',
                translate: 'MENU.MANAGE_SITES',
                desc: 'Users listing, details and action',
                root: true,
                icon: 'fa fa-building',
                page: '/manage-site',
            })
        }
        if (this.displayItems && this.displayItems.add_user) {
            this.config.aside.items.push({
                title: 'MENU.USER_MANAGEMENT',
                translate: 'MENU.USER_MANAGEMENT',
                desc: 'Users listing, details and action',
                root: true,
                icon: 'fa fa-user',
                page: '/manage-user',
            })
        }
        if (this.displayItems && this.displayItems.global_inspector) {
            this.config.aside.items.push({
                title: 'MENU.GLOBAL_INSPECTOR',
                translate: 'MENU.GLOBAL_INSPECTOR',
                desc: 'Global Inspector listing, details and action',
                root: true,
                icon: 'fa fa-user',
                page: '/manage-global-inspector',
            })
        }
        if (this.displayItems && this.displayItems.add_responders) {
            this.config.aside.items.push({
                title: 'MENU.RESPONDER',
                translate: 'MENU.RESPONDER',
                desc: 'Users listing, details and action',
                root: true,
                icon: 'fas fa-reply',
                page: '/manage-responder',
            })
        }
        if (this.displayItems && this.displayItems.manage_aed) {
            this.config.aside.items.push({
                title: 'MENU.AED',
                translate: 'MENU.AED',
                desc: 'AED listing, details and action',
                root: true,
                icon: 'fa fa-heartbeat',
                page: '/manage-aed',
            })
        }
        if (this.displayItems && this.displayItems.approve_aed) {
            this.config.aside.items.push({
                title: 'MENU.AED_REQUESTS',
                translate: 'MENU.AED_REQUESTS',
                desc: 'Users listing, details and action',
                root: true,
                icon: 'fa fa-random',
                page: '/aed-request',

            })
        }
        if (this.displayItems && this.displayItems.remove_aed) {
            this.config.aside.items.push({
                title: 'MENU.REMOVE_AED_REQUEST',
                translate: 'MENU.REMOVE_AED_REQUEST',
                desc: 'Users listing, details and action',
                root: true,
                icon: 'fas fa-user-minus',
                page: '/manage-remove-aed-request',

            })
        }
        if (this.displayItems && this.displayItems.request_replacement) {
            this.config.aside.items.push({
                title: 'MENU.STAGING_AREA',
                translate: 'MENU.STAGING_AREA',
                desc: 'Accessory replacement request list, details and action',
                root: true,
                icon: 'fas fa-sync',
                page: '/accessory-replacement-request',
                value: stageCount,
            })
        }
        this.config.aside.items.push(
            {
                title: 'MENU.PARTS_EXPIRING_SOON',
                translate: 'MENU.PARTS_EXPIRING_SOON',
                desc: 'Parts Expiring',
                root: true,                      
                icon: 'fas fa-battery-quarter',
                page: '/parts-expiring',      
                value: partExpiringCount,                 
            }
        )
        if(this.displayItems && this.displayItems.post_library){
            this.config.aside.items.push(
            {
                title: 'MENU.PARTS_EXPIRED',
                translate: 'MENU.PARTS_EXPIRED',
                desc: 'Parts Expired',
                root: true,                      
                icon: 'fas fa-calendar-times',
                page: '/parts-expired',  
                value: partExpiredCount, 
            }
            )
        }
        if (this.displayItems && this.displayItems.add_user && this.displayItems.add_company) {
            this.config.aside.items.push({
                title: 'MENU.MANAGE_FREE_TRIALS',
                translate: 'MENU.MANAGE_FREE_TRIALS',
                desc: 'manage free trials ,details and action',
                root: true,
                icon: 'fab fa-sistrix',
                page: '/manage-free-trials',
            })
        }
        if (this.displayItems && this.displayItems.add_support_user) {
            this.config.aside.items.push({
                title: 'MENU.MANAGE_SUPPORT_USERS',
                translate: 'MENU.MANAGE_SUPPORT_USERS',
                desc: 'Reseller listing, details and action',
                root: true,
                icon: 'fas fa-tasks',
                page: '/manage-support-users',
            })
        }
        if (this.displayItems && this.displayItems.add_support_user) {
            this.config.aside.items.push({
                title: 'MENU.USER_MANUAL',
                translate: 'MENU.USER_MANUAL',
                desc: 'User Manual',
                root: true,
                icon: 'fa fa-upload',
                page: '/user-manual-list',
            })
        }
        if (this.displayItems && this.displayItems.post_library) {
            this.config.aside.items.push({
                title: 'MENU.LIBRARY',
                translate: 'MENU.LIBRARY',
                desc: 'Users listing, details and action',
                root: true,
                icon: 'fas fa-book-open',
                page: '/manage-library',

            })
        }
        if (this.displayItems && this.displayItems.post_library) {
            this.config.aside.items.push({
                title: 'MENU.TRASH_BIN',
                translate: 'MENU.TRASH_BIN',
                desc: 'AED listing, details and action',
                root: true,
                icon: 'fa fa-trash',
                page: '/trash-bin',
            })
        } 
        this.config.aside.items.push({
            title: 'MENU.USER_RESTORE',
            translate: 'MENU.USER_RESTORE',
                        desc: 'User Restore',
                        root: true,                      
                        icon: 'fa fa-user-plus',
                        page: '/user-restore',  

        })
                    

        this.config.aside.items.push({
            title: 'MENU.MASTER_MODEL',
            translate: 'MENU.MASTER_MODEL',
            desc: 'Users listing, details and action',
            root: true,
            icon: 'fas fa-hotel',
            page: '/master-model',
        })
        
        if(this.displayItems && this.displayItems.post_library){
            this.config.aside.items.push(
            {
                title: 'MENU.INCIDENTS',
                translate: 'MENU.INCIDENTS',
                desc: 'Incidents',
                root: true,                      
                icon: 'far fa-calendar-alt',
                page: '/incidents',                       
            })
            this.config.aside.items.push(
            {
                title: 'MENU.REPORTS',
                translate: 'MENU.REPORTS',
                desc: 'Reports',
                root: true,                      
                icon: 'fas fa-file-alt',
                page: '/reports',                       
            })
            this.config.aside.items.push(
            {
                title: 'MENU.INSPECTIONS',
                translate: 'MENU.INSPECTIONS',
                desc: 'Inspections',
                root: true,                      
                icon: 'fas fa-search',
                page: '/inspection',

            })
            this.config.aside.items.push(
                {
                    title: 'MENU.MANAGE_RENEW_REPORT',
                    translate: 'MENU.MANAGE_RENEW_REPORT',
                    desc: 'Manage Renew Report',
                    root: true,                      
                    icon: 'fas fa-file-alt',
                    page: '/manage-renew-report',
    
                })
        }
    }
}
